import { useAuth } from "./useAuth"
import { menu } from "@app/constants"
import { filterMenu, getFirstMenuUrl } from "./useMenu"

/**
 * Возвращает путь первой страницы, доступной текущему пользователю,
 * на основе той же логики фильтрации меню что используется в навигации.
 * Если ни одна страница не доступна — возвращает null.
 */
export function useFirstAvailablePage(): string | null {
  const auth = useAuth()

  const filtered = filterMenu(menu, auth ?? null)
  return getFirstMenuUrl(filtered)
}
